import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, SelectChangeEvent, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";

import { fetchAddressById, addAddress, updateAddress } from '../../store/addressStore/addressThunk';
import { fetchCountries } from '../../store/countryStore/countryThunk';
import CustomTextField from '../FormFields/CustomTextField';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { IAddressFormInputs } from '../../utils/address.types';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { ApiStatus } from '../../utils/api.types';
import LoadingButton from '@mui/lab/LoadingButton';
import { fetchStates } from '../../store/stateStore/stateThunk';
import { Utils } from '../../utils/common-utils';

interface DialogAddressFormProps {
  title?: string;
  addressId?: string;
  open: boolean;
  onClose: (k: any) => void;
  counterPartyFlag?: boolean;
  counterPartyId?: string;
}

const DialogAddressForm: FC<DialogAddressFormProps> = ({ title, onClose, addressId, counterPartyId, counterPartyFlag, open, children }) => {

  const dispatch = useAppDispatch();
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const params = useParams();
  const [countryOptions, setCountryOptions] = useState<IOptions[]>([]);
  const [stateOptions, setStateOptions] = useState<IOptions[]>([]);
  const [addressType, setAddressType] = useState('');
  const [addressCountry, setAddressCountry] = useState('');
  const [addressState, setAddressState] = useState('');
  const [addressTypes, setAddressTypes] = useState<IOptions[]>([]);
  const [addressData, setAddressData] = useState();

  // Schema to validate account form.
  const schema = yup.object().shape({
    type: yup.string().required("Address type is required."),
    country: yup.string().required("Country is required."),
    state: yup.string().required("State is required."),
    city: yup.string().required("City is required.")
  });
  //form
  const methods = useForm<IAddressFormInputs>({ mode: 'onTouched', resolver: yupResolver(schema) });

  const { status } = useAppSelector(state => state.addresses);
  // const { countries, status: countryStatus, errorMessage: countryErrorMessage } = useAppSelector(state => state.country);

  useEffect(() => {
    const getAddressDetails = async () => {
      if (addressId) {
        const bd: any = await dispatch(fetchAddressById(addressId));

        setAddressData(bd.payload);
        setAddressType(bd.payload.type);

        methods.setValue('type', bd.payload.type);
        methods.setValue('line1', bd.payload.line1);
        methods.setValue('line2', bd.payload.line2);
        methods.setValue('line3', bd.payload.line3);
        methods.setValue('city', bd.payload.city);
        methods.setValue('state', bd.payload.state?._id || '');
        methods.setValue('country', bd.payload.country?._id);
        methods.setValue('code', bd.payload.code);
        methods.setValue('phone1', bd.payload.phone1);
        methods.setValue('phone2', bd.payload.phone2);
        setAddressCountry(bd.payload.country?._id);
        setAddressState(bd.payload.state?._id);
        
      }
    }

    getAddressDetails();
  }, [addressId, dispatch, methods]);

  useEffect(() => {
    const getCountries = async () => {
      if (!countryOptions.length) {
        const data: any = await dispatch(fetchCountries());

        setCountryOptions(data.payload.map((c: any) => {
          return { label: c.name, value: c._id }
        }));
      }
    }
    const getStateOptions = async () => {
      if (!stateOptions.length) {
        const stateData: any = await dispatch(fetchStates());
        setStateOptions(stateData.payload.map((c: any) => {
          return { label: c.name, value: c._id }
        }));
      }
    }

    if (open) {
      getCountries();
      getStateOptions();
    }

    setAddressTypes([{
      label: 'Registered',
      value: 'Registered'
    }, {
      label: 'Office',
      value: 'Office'
    }, {
      label: 'Billing',
      value: 'Billing'
    }, {
      label: 'Shipping',
      value: 'Shipping'
    }, {
      label: 'User Address',
      value: 'User-Address'
    }, {
      label: 'Misc',
      value: 'Misc'
    }])
  }, [open, dispatch, countryOptions]);

  const updateAddressDetails = async (e: any) => {
    if (addressId) {
      e.city = Utils.capitalizeFirstLetter(e.city);
      const resData: any = await dispatch(updateAddress({
        addressPayload: e,
        id: addressId
      }));

      if (!resData.error) {
        onClose(true);
      }
    }
  }

  const createAddressDetails = async (e: any) => {
    // const resData;
    console.log(counterPartyFlag);
    console.log(counterPartyId);
    console.log("first ---- ", e.city);
    e.city = Utils.capitalizeFirstLetter(e.city);
    console.log("After chagne", e.city);

    if(counterPartyFlag && counterPartyId != '') {
      const resData: any = await dispatch(addAddress({ ...e, ...{ account: selectedAccount._id, counterPartyId: counterPartyId, counterPartyFlag: counterPartyFlag } }));
      if (!resData.error) {
        onClose(true);
      }
    } else {
      const resData:any = await dispatch(addAddress({ ...e, ...{ account: selectedAccount._id } }));
      if (!resData.error) {
        onClose(true);
      }
    }
    
  }

  const onSubmit = (e: any) => {
    if (addressId) {
      updateAddressDetails(e);
      return;
    }

    createAddressDetails(e);
  }

  return (
    <div className="drawer-form-container">
      <FormProvider {...methods}>
        {(!addressId || (addressId && addressData)) &&
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "16px 0 16px 16px" }}
            component="form"
            onSubmit={methods.handleSubmit(onSubmit)}
            noValidate>
            <DialogTitle sx={{ height: "0px", mt: 1, mb: 1, justifyContent: "space-between" }}>
              <Box>
                <Typography variant="h5">{addressId ? 'Update Address Details' : 'Add Address Details'}</Typography>
              </Box>
            </DialogTitle>

            <DialogContent>
              <Grid container justifyContent="center" spacing={2} rowSpacing={-2}>
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  {addressTypes?.length && <CustomSelect
                    name="type"
                    label="Address Type*"
                    id="type"
                    required
                    variant="standard"
                    options={addressTypes}
                    value={addressType ?? ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("type", event.target.value, { shouldValidate: true });
                      setAddressType(event.target.value);
                    }} />}
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  {countryOptions?.length && <CustomSelect
                    name="country"
                    label="Country*"
                    id="country"
                    variant="standard"
                    required
                    options={countryOptions}
                    value={addressCountry ?? ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("country", event.target.value, { shouldValidate: true });
                      setAddressCountry(event.target.value);
                    }} />}
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12}>
                  {stateOptions?.length && <CustomSelect
                    name="state"
                    label="State*"
                    id="state"
                    variant="standard"
                    required
                    options={stateOptions}
                    value={addressState ?? ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("state", event.target.value, { shouldValidate: true });
                      setAddressState(event.target.value);
                    }} />}
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="City" name="city" required variant="standard" />
                </Grid>
                {/* <Grid item xs={12} md={12} sm={12} lg={12}>
                  <CustomTextField label="State" name="state" variant="standard" />
                </Grid> */}

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="Line 1" name="line1" variant="standard" />
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="Line 2" name="line2" variant="standard" />
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="Line 3" name="line3" variant="standard" />
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="Pincode" name="code" variant="standard" />
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField type="number" label="Phone 1" name="phone1" variant="standard" />
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField type="number" label="Phone 2" name="phone2" variant="standard" />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions sx={{ height: "40px", mb: 2 }}>
              <Grid container gap='0' sx={{ mr: '32px', pt: '10px' }}>
                <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >
                  <Button variant='outlined'
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      methods.reset();
                      onClose(false);
                    }}>Cancel</Button>
                  <LoadingButton
                    type="submit"
                    // disabled={!methods.formState.isValid}
                    loading={status === ApiStatus.LOADING}
                    variant="contained"
                  >
                    {addressId ? 'Update' : 'Create'}
                  </LoadingButton>
                </Grid>
              </Grid>
            </DialogActions>
          </Box>}
      </FormProvider>
    </div>
  );
};

export default DialogAddressForm;
